import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'material-ui/Checkbox';

const CheckboxInput = ({
  input,
  label,
  disabled,
}) =>
  (<Checkbox
    {...input}
    label={label}
    /* eslint no-unneeded-ternary: 0 */
    checked={input.value ? true : false}
    onCheck={input.onChange}
    style={{ maxWidth: 320 }}
    iconStyle={{ marginRight: 4 }}
    disabled={disabled}
  />);

CheckboxInput.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
};

export default CheckboxInput;



// WEBPACK FOOTER //
// ./src/components/form/CheckboxInput.js